import {
  secondaryRebrandTheme,
  type ThemeType,
} from 'radiance-ui/lib/constants';

/**
 * The `__type` value radiance-ui assigns to the Agency rebrand theme
 * (`secondaryRebrandTheme`). All Agency rebrand styling keys off this value so
 * Curology (`primary`) and flag-off Agency (`secondary`) remain unaffected.
 */
export const AGENCY_REBRAND_THEME_TYPE = secondaryRebrandTheme.__type;

export const isAgencyRebrand = (theme: ThemeType): boolean =>
  theme.__type === AGENCY_REBRAND_THEME_TYPE;
